module.exports = __webpack_public_path__ + "img/zt_pic00.d79be598.png";